import * as React from 'react';
import {View, Text, StyleSheet, TouchableOpacity, FlatList} from 'react-native';
import {Color, globalFontStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import EventChildComponent from '../../event/childComponents/EventChildComponent';
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {globalConfigurableData, GlobalScreens} from "../../../utils/globalConstant";

const ListOfTrades = ({orderList = []}) => {
  return (
    <View>
      <View>
        <View style={{flexDirection: 'row', marginBottom: 15}}>
          <FormTextLabel labelStyles={[styles.colStyle, styles.headerCol]} label={"QUANTITY"} />
          <FormTextLabel labelStyles={[styles.colStyle, styles.center, styles.headerCol]} label={"PRICE"} />
          <FormTextLabel labelStyles={[styles.colStyle, styles.right, styles.headerCol]} label={"STATUS"} />
        </View>
        <View
          style={{
            maxHeight: 220,
            //borderWidth: 0.5,
            //borderRadius: 5,
            marginBottom: 10,
          }}>
          <FlatList
            // ListHeaderComponent={headerCompoenent}
            nestedScrollEnabled={true}
            data={orderList}
            renderItem={({item}) => {
              return (
                <View style={{flexDirection: 'row', alignItems: 'center'}}>
                  <Text
                    style={[
                      styles.colStyle,
                      styles.rowTxt,
                      item?.callvalue === 'N'
                        ? {color: GlobalScreens.Event.noBtnTxt}
                        : {color: GlobalScreens.Event.yesBtnTxt},
                    ]}>
                    {item?.callvalue === 'N' ? 'No ' : 'Yes '}
                    {item?.orderInfo?.contracts?.toFixed(2)}
                  </Text>
                  <Text style={[styles.colStyle, styles.center, styles.rowTxt]}>
                    {item?.orderInfo?.coins?.toFixed(2)}
                  </Text>
                  <Text style={[styles.colStyle, styles.right, styles.rowTxt]}>
                    {item?.orderStatus}
                  </Text>
                </View>
              );
            }}
            keyExtractor={(item, index) => index}
            showsVerticalScrollIndicator={false}
            initialNumToRender={10}
          />
        </View>
      </View>
    </View>
  );
};

export default ListOfTrades;

const styles = StyleSheet.create({
  colStyle: {
    flex: 1,
    flexBasis: 0,
  },
  headerCol: {
    ...globalFontStyle.appFontSmallText,
    lineHeight: 19,
    color: globalConfigurableData.secondaryTextColor1,
  },
  center: {
    textAlign: 'center',
  },
  right: {
    textAlign: 'right',
  },
  rowTxt: {
    ...globalFontStyle.appFontSubText,
    lineHeight: 19,
    color: globalConfigurableData.tertiaryTextColor1,
  },
});
